(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.factory('WebsocketService', ['$rootScope', '$state', '$timeout', '$translate', 'Alert', WebsocketServiceFn]);

    function WebsocketServiceFn($rootScope, $state, $timeout, $translate, Alert) {

        // websocket protocol 
        var protocol = 'wss';         

        var reconnectTimeout = 250;
        var timeoutIncrease = 250;
        var tryReconnect = true;

        var webSocketServerUrl;
        
        // subscribers
        var subscribers = [];

        var authenticationToken = null;
        
        var service = {
            ws: null
        };

        // connect to websocket server
        service.connect = function (isRingfoon, webSocketServerEndpoint) {
            if (service.ws !== null && service.ws.readyState === WebSocket.OPEN) { return; } // still connected

            if (!webSocketServerUrl && webSocketServerEndpoint) {
                webSocketServerUrl = webSocketServerEndpoint;
            }

            // websocket protocol -> if ringfoon -> declare as that
            var wsProtocol = []; // default
            if (isRingfoon && isRingfoon === true) { wsProtocol = ["Ringfoon"]; }

            // connect to server with authorization token
            var endpoint = protocol + "://" + webSocketServerEndpoint + "/ws";
            
            // add token to query parameter for authorization
            if (authenticationToken) {
                endpoint += "?authorization=" + encodeURIComponent(authenticationToken);
            } else {
                // unable to authorize thus connect
                return;
            }
            
            service.ws = new WebSocket(endpoint, wsProtocol);
            tryReconnect = true;

            // websocket handler functions
            service.ws.onopen = function () {
            };

            service.ws.onerror = function () {
                service.ws.close();
            };

            service.ws.onmessage = function (message) {
                service.receive(message.data);
            };

            service.ws.onclose = function (closeMessage) {
                if (tryReconnect) {
                    setTimeout(function() {                        
                        service.connect($rootScope.isRingfoon, webSocketServerUrl);                    
                    }, Math.min(10000, reconnectTimeout += timeoutIncrease))
                }              
            }
        };

        // send message to server
        service.send = function (message) {
            if (service.ws === null) { return; }

            // only when ready
            if (service.ws.readyState !== WebSocket.OPEN) { return; }

            // when ready -> send
            service.ws.send(JSON.stringify(message));
        };

        // register for events 
        service.register = function (websocketRegisterType, callback) {
            // new subscriber object
            // key -> type of register to listen on
            // value -> the callback - function
            var subscriber = {
                id: Math.random(),
                type: websocketRegisterType,
                callback: callback
            };
            subscribers.push(subscriber);
            return subscriber;
        };

        // unregister for event
        service.unregister = function (id) {
            var i = 0;
            var len = subscribers.length; 
            for (i; i < len; i++) {
                if (subscribers[i].id === id) {
                    subscribers.splice(i, 1); // remove
                    return;
                } // if
            } // for
        };

        // handle message from server
        service.receive = function (message) {
            // loop over subscriber -> identify websocket-type
            // only inform relevant subscriber
            // is type available ?
            var wsMessage = JSON.parse(message);
            if (wsMessage && wsMessage.type) {                
                var i = 0;
                var len = subscribers.length;
                for (i; i < len; i++) {
                    if (subscribers[i].type === wsMessage.type) {
                        subscribers[i].callback(wsMessage);
                    } // if
                } // for
            } // if
        };

        // disconnect
        service.close = function () {
            if (service.ws === null) { return; }
            
            var goodbye = $translate.instant('bye');

            subscribers = []; 
            tryReconnect = false;           
            service.ws.close(1000, goodbye);
            service.ws = null;
            authenticationToken = null;

            Alert.info(goodbye);
        };
        
        service.setAuthenticationToken = function(token) {
            authenticationToken = token;
        }

        return service;

    }
})();